var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isExternal
        ? _c(
            "a",
            {
              staticClass: "hover-noline",
              attrs: { target: "_blank", href: _vm.externalLink }
            },
            [
              _c(
                "div",
                { staticClass: "featureCardWrapper pa-1 pa-xs-2 pa-md-3" },
                [
                  _c(
                    "div",
                    { staticClass: "featureIcon" },
                    [_vm._t("default")],
                    2
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "cardText" }, [
                    _vm._v(_vm._s(_vm.featureText))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "cardText" })
                ]
              )
            ]
          )
        : _c(
            "router-link",
            { staticClass: "hover-noline", attrs: { to: _vm.featureLink } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "featureCardWrapper pa-4 pa-xs-8 pa-md-10 pa-lg-12 pa-xl-12"
                },
                [
                  _c(
                    "div",
                    { staticClass: "featureIcon" },
                    [_vm._t("default")],
                    2
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "cardText" }, [
                    _vm._v(_vm._s(_vm.featureText))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "cardText" })
                ]
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b70fea8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b70fea8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing/landingComponents/FeatureCard.vue
// module id = null
// module chunks = 